import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-modes',
  imports: [],
  templateUrl: './payment-modes.html',
  styleUrl: './payment-modes.scss'
})
export class PaymentModes {

}
